import comp from "./AddChildPage";
export default comp;
